export const validateForm = (startDate, rate, desiredClients, errorMessages) => {
  if (startDate === null || startDate === undefined) {
    return { valid: false, message: errorMessages.START_DATE };
  }
  if (rate === 0) {
    return { valid: false, message: errorMessages.RATE };
  }
  if (desiredClients === 0) {
    return { valid: false, message: errorMessages.DESIRED_CLIENTS };
  }
  return { valid: true };
};

export const calculateWeeklyIncome = (rate, clients, sessionLength) =>
  (rate * clients * sessionLength).toLocaleString();

export const calculateAnnualIncome = (rate, clients, sessionLength) =>
  (rate * clients * sessionLength * 52).toLocaleString();
